// extracted by mini-css-extract-plugin
export default {"p":"_903115e75b _638f0a42e1 fef0125fcd","clr":"ff187ffc82","dls":"_504832e434"};